import type { NodeTypes } from '@xyflow/react'
import LLMNode from './nodes/LLMNode'
import MCPNode from './nodes/MCPNode'
import DataNode from './nodes/DataNode'
import ConditionNode from './nodes/ConditionNode'
import IONode from './nodes/IONode'
import CodeNode from './nodes/CodeNode'
import RecipeCallNode from './nodes/RecipeCallNode'

export const recipeNodeTypes: NodeTypes = {
  llm: LLMNode,
  mcp: MCPNode,
  data: DataNode,
  condition: ConditionNode,
  io: IONode,
  code: CodeNode,
  recipe: RecipeCallNode,
}
